<template>
  <div>
    <div v-if="!noIcon" class="menu-item">
      <span v-if="project !== 'spati'" class="menu-title has-text-weight-semibold">
        {{ $t('cart.title') }} ({{ getCount }})
      </span>
      <svg v-if="project !== 'spati'" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38"><title>Cart</title><circle cx="19" cy="19" r="19" fill="#e32f31" /><path d="M24.17,21.89h-8a.76.76,0,0,1-.74-.6l-1.86-9L11,12.21a.75.75,0,0,1-.72-.78.74.74,0,0,1,.78-.72l3.17.14a.74.74,0,0,1,.7.59l.6,2.87h10a.79.79,0,0,1,.58.28.76.76,0,0,1,.15.63l-1.27,6.07A.76.76,0,0,1,24.17,21.89Zm-7.41-1.5h6.8l1-4.58H15.81Z" fill="#fff" /><path d="M23,28.16a2,2,0,1,1,2-2A2,2,0,0,1,23,28.16Zm0-2.5a.5.5,0,0,0-.5.5.5.5,0,0,0,1,0A.5.5,0,0,0,23,25.66Z" fill="#fff" /><path d="M17,28.16a2,2,0,1,1,2-2A2,2,0,0,1,17,28.16Zm0-2.5a.5.5,0,0,0-.5.5.5.5,0,0,0,1,0A.5.5,0,0,0,17,25.66Z" fill="#fff" /></svg>
      <svg
        v-else
        width="24"
        height="24"
        viewBox="0 0 64 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M28.5419 56.91C28.5419 59.52 26.4219 61.64 23.8119 61.64C21.2019 61.64 19.0819 59.52 19.0819 56.91C19.0819 54.3 21.2019 52.18 23.8119 52.18C26.4219 52.18 28.5419 54.3 28.5419 56.91ZM53.8119 52.18C51.2019 52.18 49.0819 54.3 49.0819 56.91C49.0819 59.52 51.2019 61.64 53.8119 61.64C56.4219 61.64 58.5419 59.52 58.5419 56.91C58.5419 54.3 56.4219 52.18 53.8119 52.18ZM25.6619 45.27H52.1319C55.7319 45.37 58.8819 42.82 59.5919 39.25L63.9519 16.37C64.0619 15.78 63.9119 15.18 63.5319 14.72C63.1519 14.26 62.5819 13.99 61.9919 13.99H17.2819L14.8719 1.96001C14.6819 1.03001 13.8619 0.350006 12.9119 0.350006H2.00189C0.901892 0.360006 0.00189209 1.26001 0.00189209 2.36001C0.00189209 3.46001 0.901892 4.36001 2.00189 4.36001H11.2719L13.6619 16.29C13.6619 16.35 13.6819 16.42 13.7019 16.48L18.2619 39.26C18.9619 42.76 22.0219 45.26 25.5319 45.26C25.5819 45.26 25.6319 45.26 25.6719 45.26L25.6619 45.27ZM59.5719 18L55.6619 38.49C55.3419 40.11 53.9219 41.27 52.2419 41.27C52.2219 41.27 52.1919 41.27 52.1719 41.27H25.6219C23.9119 41.31 22.4919 40.13 22.1619 38.49L18.0619 18H59.5619H59.5719Z" fill="black" />
      </svg>
    </div>
    <div v-else class="button is-primary is-fullwidth" @click.stop="$store.dispatch('page/isOpenedCartToggle')">
      {{ $t('cart.title') }} ({{ getCount }})
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getCart () {
      return this.$store.state.page.cart
    },
    getCount () {
      return this.getCart && this.getCart.quantity ? this.getCart.quantity : 0
    }
  },
  methods: {
    toggleOpenCart () {
      this.$store.dispatch('page/isOpenedCartToggle')
    }
  }
}
</script>
